import { render, staticRenderFns } from "./PPCThumbnailCard.vue?vue&type=template&id=6202f7f8&scoped=true&"
import script from "./PPCThumbnailCard.vue?vue&type=script&lang=js&"
export * from "./PPCThumbnailCard.vue?vue&type=script&lang=js&"
import style0 from "./PPCThumbnailCard.vue?vue&type=style&index=0&id=6202f7f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6202f7f8",
  null
  
)

export default component.exports